
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/contexts/ThemeContext";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Production from "./pages/Production";
import DistributionMarketing from "./pages/DistributionMarketing";
import CelebrityManagement from "./pages/CelebrityManagement";
import MediaStrategy from "./pages/MediaStrategy";
import AntiPiracy from "./pages/AntiPiracy";
import ORM from "./pages/ORM";
import About from "./pages/About";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <TooltipProvider>
        <div className="min-h-screen transition-colors duration-300">
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/production" element={<Production />} />
              <Route path="/distribution-marketing" element={<DistributionMarketing />} />
              <Route path="/celebrity-management" element={<CelebrityManagement />} />
              <Route path="/media-strategy" element={<MediaStrategy />} />
              <Route path="/anti-piracy" element={<AntiPiracy />} />
              <Route path="/orm" element={<ORM />} />
              <Route path="/about" element={<About />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-conditions" element={<TermsConditions />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </div>
      </TooltipProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;
